import { u as d } from "../../../floating-ui.react--Sr3isS-.js";
import { forwardRef as v, isValidElement as s, Children as P, cloneElement as w } from "react";
import M from "../hooks/usePopoverContext.js";
const a = v(({ children: e, ...i }, o) => {
  const {
    context: {
      open: t
    },
    refs: p,
    getReferenceProps: c
  } = M(), r = (() => {
    if (typeof e == "function") {
      const n = e({ isOpen: t, forwardedRef: o });
      if (!s(n))
        throw new Error("Function child of MarketPopoverTrigger must return a valid React element");
      return n;
    }
    if (P.count(e) !== 1)
      throw new Error("MarketPopoverTrigger must have exactly one child element");
    if (!s(e))
      throw new Error("MarketPopoverTrigger requires a valid React element as children");
    return e;
  })(), { ref: f, ...l } = r.props, m = f ?? r.ref ?? null, u = d([p.setReference, o, m]), g = {
    "data-status": t ? "open" : "closed",
    ref: u,
    ...i
  };
  return w(
    r,
    {
      ...c(g),
      ...l
    }
  );
});
a.displayName = "MarketPopoverTrigger";
const E = a;
export {
  a as ForwardedMarketPopoverTrigger,
  E as MarketPopoverTrigger
};
